import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CoachViewProfileCard from './CoachViewProfileCard';
import Img from '../../Img';
import LoadingText from '../../text/LoadingText';

import useStartPowerCheckout from '../../hooks/useStartPowerCheckout';
import styles from './collegeCoachViews.scss';
import { PowerFunnelSurfaces, PowerFunnelGatedFeatures } from '../../Analytics/constants';

function CollegeCoachViews({ collegeCoachViews }) {
    const isPowerUser = useSelector((state) => state.auth?.user?.isPowered);
    const isLoadingCollegeCoachViews = useSelector((state) => state.profile?.profileViewsState?.loading);
    const params = useParams();
    const { startPowerCheckout, hasPastDueSubscription } = useStartPowerCheckout();

    const { views, total } = collegeCoachViews || {};
    const viewString = total > 1 ? 'Views' : 'View';
    const title = `${total} College Coach ${viewString}`;
    const viewAllPath = `/college-coach-views/${params?.playerId}`;

    const handleOnUnlockPowerClick = (event) => {
        event.preventDefault();
        event.stopPropagation();

        startPowerCheckout({
            surface: PowerFunnelSurfaces.PLAYER_PROFILE,
            gatedFeature: PowerFunnelGatedFeatures.COLLEGE_COACH_VIEWS,
        });
    };

    const getLockCount = () => {
        const maxLocksToShow = 8;
        const totalLocks = total >= maxLocksToShow ? maxLocksToShow : total;
        return Array.from({ length: totalLocks }, (_, index) => ({ id: index + 1 }));
    };

    if (isLoadingCollegeCoachViews) {
        return (
            <div>
                <h6 className="text-semi mt48">College Coach Views</h6>
                <div className={styles.contentContainer}>
                    <LoadingText text={'Loading Views'} />
                </div>
            </div>
        );
    }

    return (
        <div>
            <h6 className="text-semi mt48">College Coach Views</h6>
            {isPowerUser ? (
                <div className={styles.contentContainer}>
                    <div className="d-flex jsb">
                        <p className={styles.title}>{title}</p>
                        <a className={styles.link} href={viewAllPath}>View All</a>
                    </div>
                    {views?.map((view, index) => {
                        const maxLocksToShow = 3;
                        const showLockIcon = index < maxLocksToShow;
                        if (showLockIcon) {
                            return (
                                <CoachViewProfileCard view={view} key={view?.id} />
                            );
                        }
                        return null;
                    })}
                </div>
            ) : (
                <div className={styles.contentContainer}>
                    <div className="d-flex jsb">
                        <p className={styles.title}>{title}</p>
                    </div>
                    <div className={styles.lockContainer}>
                        {getLockCount().map((lock) => {
                            return (
                                <div key={lock?.id}>
                                    <Img className="mr4 mb4" src="/img/v2/icons/icon-feature-lock.svg" />
                                </div>
                            );
                        })}
                    </div>
                    <button
                        type="button"
                        className={styles.powerButton}
                        onClick={handleOnUnlockPowerClick}
                    >
                        {hasPastDueSubscription ? 'Resume Power' : (
                            <>Unlock this list with <b>POWER</b></>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
}

CollegeCoachViews.propTypes = {
    collegeCoachViews: PropTypes.shape({
        views: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
        })),
        total: PropTypes.number,
    }).isRequired,
};

export default CollegeCoachViews;
